export default __webpack_public_path__ + "static/media/google-plus.31c8e38d.svg";